import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BORDER_RADIUS, PADDING } from 'parkway-web-common'
import { useState } from 'react'
import styled from 'styled-components'
import { AddRelativesModal, ItemRelatives } from './components'
import { ExamplePatient } from 'app/containers/DentalTreatmentManagement/ProfilePatientRecord/constant/emergency-contact'

export const RelativesLayout = () => {
  const [patient] = useState([ExamplePatient, ExamplePatient])
  return (
    <RootWrapper>
      <BaseRow align={'middle'} justify={'end'}>
        <AddRelativesModal />
      </BaseRow>

      {patient?.map((item, index) => {
        return <ItemRelatives item={item} index={index} key={index} />
      })}
    </RootWrapper>
  )
}
const RootWrapper = styled(BaseSpace)`
  padding: ${PADDING.xxs};
  background-color: #f9fafb; // need change
  border-radius: ${BORDER_RADIUS};
`
